import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import Product from 'ui/components/modules/Products/Product'
import theme from 'ui/styles/theme'

export default class IndustryProducts extends Component {
    render() {
        const { heading, featured, bgcolor } = this.props

        return (
            <Wrapper bgcolor={bgcolor}>
                <HeroWrapper fluid>
                    <Heading>
                        {heading}
                    </Heading>
                    <Row style={rowStyle}>
                        {featured.map((product, index) => {
                            return (
                                <Col xs={4} sm={3} key={index} style={colStyle}>
                                    <Product
                                        noMargin
                                        showOverlay
                                        link={product.product.link}
                                        image={product.product.image.sourceUrl}
                                        title={''}
                                        video={product.product.video.sourceUrl}
                                    />
                                    <ProductName>{product.sensor_name}</ProductName>
                                </Col>
                            )

                        })}
                    </Row>
                </HeroWrapper>
            </Wrapper>
        )
    }
}

const rowStyle = {
    marginBottom: '40px'
}

const colStyle = {
    marginTop: '40px'
}

const Wrapper = styled.div`
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
                    `
const HeroWrapper = styled(Container)`
                    padding: 0 20px;
                    ${media.lg`
                    padding: 0 20%;
                    `}
                    `
const Heading = styled.h2`
font-size: 35px !important;
font-weight: 350 !important;
line-height: 1.2 !important;
margin-bottom: 0px !important;
`

const ProductName = styled.div`
${media.md`
margin-top: 5px;
`}

`




// WEBPACK FOOTER //
// ./src/ui/components/modules/IndustryProducts/index.js